import { Typography } from "@mui/material";
import React from "react";

const GasPercentageUsed = ({ block }) => {
  return ((block.gasUsed / block.gasLimit) * 100).toFixed(5);
};

export default GasPercentageUsed;
